/**
 * CetusEd NextGen — the public /login route.
 *
 * Already authenticated → bounce to the landing (no reason to show a login
 * form to a signed-in user). Session not yet determined → a neutral loading
 * state. Otherwise → the login form.
 */
import { Navigate } from 'react-router-dom'
import { useSession } from '../../core/session/SessionProvider'
import { LoginForm } from './LoginForm'
import { SessionLoading } from './SessionLoading'

export function LoginPage() {
  const { status } = useSession()

  if (status === 'authenticated') {
    return <Navigate to="/" replace />
  }

  if (status === 'unknown' || status === 'restoring') {
    return <SessionLoading label="Loading…" />
  }

  return <LoginForm />
}
